import React from 'react';

const NebulaIcon = ({ size, color }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="3" stroke={color} strokeWidth="1.5"/>
        <ellipse cx="12" cy="12" rx="10" ry="4.5" stroke={color} strokeWidth="1.2"/>
        <ellipse cx="12" cy="12" rx="10" ry="4.5" transform="rotate(60 12 12)" stroke={color} strokeWidth="1.2"/>
        <ellipse cx="12" cy="12" rx="10" ry="4.5" transform="rotate(120 12 12)" stroke={color} strokeWidth="1.2"/>
    </svg>
);

const SimplizeIcon = ({ size, color }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <path d="M12 2L14.09 8.26L20.18 8.27L15.54 12.14L17.64 18.38L12 14.47L6.36 18.38L8.46 12.14L3.82 8.27L9.91 8.26L12 2Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
);

const ICONS = {
    nebula: NebulaIcon,
    simplize: SimplizeIcon,
};

export default function BrandIcon({ icon = 'nebula', size = 16, color = '#4D4D4D' }) {
    const Icon = ICONS[icon] || ICONS.nebula;
    return <Icon size={size} color={color} />;
}
